import { c as _c } from "react/compiler-runtime";
import { Avatar, AvatarFallback, AvatarImage } from "@repo/ui/components/ui/avatar";
import { useQuery } from "@tanstack/react-query";
import { Trophy } from "lucide-react";
import { trpc } from "@/router";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const RANK_STYLES = {
  1: "text-2xl",
  2: "text-xl",
  3: "text-lg"
};
const RANK_MEDALS = {
  1: "bg-yellow-100 border-yellow-300",
  2: "bg-gray-100 border-gray-300",
  3: "bg-orange-50 border-orange-300"
};
function getInitials(name) {
  return name.split(" ").map(n => n[0]).join("").toUpperCase().slice(0, 2);
}
export function LeaderboardView() {
  const $ = _c(12);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = trpc.features.leaderboard.queryOptions();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: entries,
    isLoading
  } = useQuery(t0);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsxs("div", {
      className: "mb-6 flex items-center gap-3",
      children: [/*#__PURE__*/_jsx(Trophy, {
        className: "text-brand h-7 w-7"
      }), /*#__PURE__*/_jsx("h1", {
        className: "text-2xl font-bold",
        children: "Topplista"
      })]
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isLoading) {
    t2 = isLoading && /*#__PURE__*/_jsx("div", {
      className: "space-y-3",
      children: [...Array(3)].map(_temp)
    });
    $[2] = isLoading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== entries) {
    t3 = entries && entries.length === 0 && /*#__PURE__*/_jsxs("div", {
      className: "rounded-lg border border-dashed p-8 text-center text-gray-500",
      children: [/*#__PURE__*/_jsx(Trophy, {
        className: "mx-auto mb-3 h-10 w-10 text-gray-300"
      }), /*#__PURE__*/_jsx("p", {
        className: "font-medium",
        children: "Inga bidrag \xE4nnu"
      }), /*#__PURE__*/_jsx("p", {
        className: "mt-1 text-sm",
        children: "Bli f\xF6rst med att kartl\xE4gga en plats!"
      })]
    });
    $[4] = entries;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== entries) {
    t4 = entries && entries.length > 0 && /*#__PURE__*/_jsx("ol", {
      className: "space-y-2",
      children: entries.map(_temp2)
    });
    $[6] = entries;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t3 || $[10] !== t4) {
    t5 = /*#__PURE__*/_jsxs("div", {
      className: "mx-auto max-w-lg px-4 py-8",
      children: [t1, t2, t3, t4]
    });
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp2(entry, i_0) {
  const rank = i_0 + 1;
  const medal = RANK_MEDALS[rank];
  const sizeClass = RANK_STYLES[rank] ?? "text-base";
  return /*#__PURE__*/_jsxs("li", {
    className: `flex items-center gap-4 rounded-lg border p-3 transition-colors ${medal ?? "border-gray-100 bg-white"}`,
    children: [/*#__PURE__*/_jsx("span", {
      className: `w-8 text-center font-bold tabular-nums text-gray-400 ${sizeClass}`,
      children: rank
    }), /*#__PURE__*/_jsxs(Avatar, {
      className: "h-10 w-10",
      children: [entry.image && /*#__PURE__*/_jsx(AvatarImage, {
        src: entry.image
      }), /*#__PURE__*/_jsx(AvatarFallback, {
        className: "bg-brand/10 text-brand text-sm font-medium",
        children: getInitials(entry.name)
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "min-w-0 flex-1",
      children: [/*#__PURE__*/_jsx("p", {
        className: "truncate font-medium",
        children: entry.name
      }), /*#__PURE__*/_jsxs("p", {
        className: "text-sm text-gray-500",
        children: [entry.contributions, " ", entry.contributions === 1 ? "bidrag" : "bidrag"]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "text-right",
      children: [/*#__PURE__*/_jsx("span", {
        className: "text-brand text-lg font-bold tabular-nums",
        children: entry.score.toLocaleString("sv-SE")
      }), /*#__PURE__*/_jsx("p", {
        className: "text-xs text-gray-400",
        children: "po\xE4ng"
      })]
    })]
  }, entry.userId);
}
function _temp(_, i) {
  return /*#__PURE__*/_jsx("div", {
    className: "h-16 animate-pulse rounded-lg bg-gray-100"
  }, i);
}